import React, { useRef, useState } from 'react';
import PrematchResults from './PrematchResults';
import SearchDataProvider from './SearchDataProvider';
import useIsLiveSection from '../useIsLiveSection';
import LiveResults from './LiveResults';
import OverlayWrapper from '../OverlayWrapper';
import { getLabel } from '../../data/labels';
import CombinedResults from './CombinedResults';
import SearchLiveDataProvider from './SearchLiveDataProvider';

export default function SearchAlt(props) {
    const isLiveSection = useIsLiveSection();

    const [search, setSearch] = useState('');
    const ref = useRef(null);

    function handleChange(event) {
        setSearch(event.target.value);
    }

    // function handleReset() {
    //     ref.current.value = '';
    //     ref.current.focus();
    //     setSearch('');
    // }

    return (
        <OverlayWrapper id="xs-search-overlay">
            <div className="searchAlt__wrapper xs_searchResultsDropdown z-30 absolute container top-0 left-0 right-0 bottom-0">
                <div className="h-full overflow-y-auto flex flex-col bg-cs1">
                    <div className='flex items-center gap-[10px] h-[56px] px-[30px]'>
                        <div className="col-start-1 col-end-3 justify-self-center inline-block" onClick={props.toggle}>
                            <i className="bi-arrow-left font-medium text-lg text-cs-3"></i>
                        </div>
                        <div className='horizontal__divider' />
                        <div className='searchAlt__title'>
                            <span>{getLabel('general.find')}</span>
                        </div>
                    </div>
                    <div className="relative searchAlt__input__wrapper z-20 top-0 shrink-0 h-[50px] flex items-center bg-cs1">
                        <input className="searchAlt__input  px-2 font-medium text-lg text-cs-3 outline-0"
                            placeholder={getLabel('general.search')}
                            onChange={handleChange}
                            ref={ref}
                            autoFocus />
                        <i className="bi-search absolute right-2 top-1/2 -translate-y-1/2  pointer-events-none searchButton__icon"></i>
                        {/* <div className="col-start-11 col-end-13 justify-self-center font-normal text-sm text-cs-3">
                            <i className="bi-x-lg mx-auto font-medium text-lg text-cs-3" onClick={handleReset}></i>
                        </div> */}
                    
                    </div>
                    {search.length > 3 &&
                        (props.combinedResults ? (<SearchLiveDataProvider>
                            <SearchDataProvider>
                                <CombinedResults search={search} toggle={props.toggle} />
                            </SearchDataProvider>

                        </SearchLiveDataProvider>)
                            :
                            (isLiveSection ?
                                <LiveResults search={search} toggle={props.toggle} />
                                :
                                <SearchDataProvider>
                                    <PrematchResults search={search} toggle={props.toggle} />
                                </SearchDataProvider>
                            )
                        )
                    }
                </div>
            </div>
        </OverlayWrapper>
    );
}

